import { render, staticRenderFns } from "./copeManage.vue?vue&type=template&id=d4656a7c&scoped=true"
import script from "./copeManage.vue?vue&type=script&lang=js"
export * from "./copeManage.vue?vue&type=script&lang=js"
import style0 from "./copeManage.vue?vue&type=style&index=0&id=d4656a7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4656a7c",
  null
  
)

export default component.exports